/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import { fetchCategories } from '../../../lib/fetchBlogs';

// Icons mapping
import { 
  MdHomeFilled, 
  MdTrendingUp, 
  MdSportsEsports,
  MdSportsSoccer,
  MdBusiness,
  MdCurrencyBitcoin,
  MdComputer,
  MdScience,
  MdHealthAndSafety,
  MdMovie,
  MdSchool,
  MdFlight,
  MdRestaurant,
  MdCheckroom,
  MdMusicNote,
  MdBrush,
  MdMenuBook,
  MdLocalMovies,
  MdCameraAlt,
  MdDesignServices,
  MdAttachMoney,
  MdStore,
  MdRocketLaunch,
  MdSmartToy,
  MdAccountBalance
} from 'react-icons/md';

// Map icon names to components
const iconComponents = {
  home: MdHomeFilled,
  trending: MdTrendingUp,
  gaming: MdSportsEsports,
  sports: MdSportsSoccer,
  business: MdBusiness,
  crypto: MdCurrencyBitcoin,
  tech: MdComputer,
  science: MdScience,
  health: MdHealthAndSafety,
  entertainment: MdMovie,
  education: MdSchool,
  travel: MdFlight,
  food: MdRestaurant,
  fashion: MdCheckroom,
  music: MdMusicNote,
  art: MdBrush,
  books: MdMenuBook,
  movies: MdLocalMovies,
  photography: MdCameraAlt,
  design: MdDesignServices,
  finance: MdAttachMoney,
  marketing: MdStore,
  startup: MdRocketLaunch,
  ai: MdSmartToy,
  blockchain: MdAccountBalance,
};

// Default category for "All"
const defaultCategory = {
  _id: 'all',
  title: 'All',
  slug: { current: 'all' },
  description: 'View all blog posts',
  icon: 'home'
};

// Fallback icon component
const DefaultIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6 6 0 011.912-4.26 48.626 48.626 0 00-2.542 4.26h.63zm13.41-4.26a6 6 0 011.912 4.26h-.63a48.626 48.626 0 00-2.542-4.26zM10 12a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
  </svg>
);

export default function CategoryList({ selectedCategory, onCategoryHandler }) {
  const [categories, setCategories] = useState([defaultCategory]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function loadCategories() {
      try {
        const fetchedCategories = await fetchCategories();
        setCategories([defaultCategory, ...fetchedCategories]);
      } catch (error) {
        console.error('Failed to load categories:', error);
      } finally {
        setIsLoading(false);
      }
    }

    loadCategories();
  }, []);

  const getIconComponent = (iconName) => {
    const IconComponent = iconComponents[iconName] || DefaultIcon;
    return <IconComponent size={20} className="text-blue-600" />;
  };

  if (isLoading) {
    return (
      <div className="category-container">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-12 bg-gray-100 rounded-md animate-pulse my-1"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="category-container">
      {categories.map((category) => {
        const Icon = getIconComponent(category.icon || 'default');
        return (
          <div key={category._id}>
            <button
              onClick={() => onCategoryHandler(category.title === 'All' ? 'All' : category.title)}
              className={`category-button ${
                selectedCategory === category.title ? 'category-button-selected' : ''
              }`}
            >
              {Icon}
              <h3 className="category-name">{category.title}</h3>
            </button>
          </div>
        );
      })}
    </div>
  );
}
